<template>
  <div
    v-if="loaded"
    class="d-flex flex-column pt-0 flex-1 position-relative"
    :class="{alignItemsCenter: !hasPeople}"
  >
    <case-back-div
      v-if="false"
      :to="backTo"
    />
    <route-breadcrumb />
    <individual
      v-if="actor"
      class="px-6"
      user-type="subject"
      :back-to="backTo"
      :people="actor"
      @updated="loadPeople"
    />
    <div
      v-else-if="hasPeople"
      class="p-5"
    >
      <div class="d-flex justify-content-between align-items-center mb-2">
        <div>
          <h6 class="text-white case-people--tile mb-0">
            People
          </h6>
          <h5 class="text-lightblue">
            Assigned to this case: {{ peopleCount }}
          </h5>
        </div>
        <base-button
          v-if="hasPeople"
          type="simple"
          @click="openAddPeopleModal"
        >
          <plus-icon
            size="1.5x"
            class="mr-1"
          />
          People
          <add-people-modal
            ref="addPeople"
            :case-id="caseId"
            @created="loadPeople"
          />
        </base-button>
      </div>
      <case-people-table
        :users="users"
        :actors="actors"
        @remove="removeAttribution"
        @viewActor="viewActor"
      />
    </div>
    <wizard-container
      v-else
      show-only="people"
      @created="loadPeople"
    />
  </div>
</template>

<script>
import {PlusIcon} from "vue-feather-icons";
import {mapActions, mapGetters, mapMutations} from "vuex";
import {unattributeActor, unattributeUser} from "../../../api";
import {isDefined} from "../../../api/helpers";
import BaseButton from "../../../components/BaseButton.vue";
import AddPeopleModal from "../../../components/DashboardV2/Case/AddPeopleModal.vue";
import CaseBackDiv from "../../../components/DashboardV2/Case/CaseBackDiv.vue";
import CasePeopleTable from "../../../components/DashboardV2/Case/CasePeopleTable.vue";
import WizardContainer from "../../../components/DashboardV2/Wizard/CaseWizard.vue";
import {ethosRouteNames} from "../../../routes/routeNames";
import Individual from "../People/Individual/Individual.vue";
export default {
  components: {WizardContainer, BaseButton, AddPeopleModal, CaseBackDiv, PlusIcon, CasePeopleTable, Individual},
  data() {
    return {
      loading: true,
      loaded: false,
      removing: false,
    };
  },
  computed: {
    ...mapGetters("data", ["getCaseActorAttributions", "getCaseUserAttributions"]),
    peopleCount() {
      return this.actors.length + this.users.length;
    },
    hasPeople() {
      return this.peopleCount > 0;
    },
    caseId() {
      const id = this.$route.params.caseId;
      return isDefined(id) ? parseInt(id, 10) : null;
    },
    actorId() {
      const id = this.$route.params.actorId;
      return isDefined(id) ? parseInt(id, 10) : null;
    },
    actor() {
      if (!isDefined(this.actorId)) return null;
      return this.actors.filter((a) => a.id === this.actorId).pop();
    },
    backTo() {
      return isDefined(this.actorId) ? ethosRouteNames.CasePeople : ethosRouteNames.DashboardV2;
    },
    actors() {
      if (!isDefined(this.caseId) || !isDefined(this.getCaseActorAttributions)) return [];
      return this.getCaseActorAttributions[this.caseId] ?? [];
    },
    users() {
      if (!isDefined(this.caseId) || !isDefined(this.getCaseUserAttributions)) return [];
      return this.getCaseUserAttributions[this.caseId] ?? [];
    },
  },
  mounted() {
    this.loadPeople();
  },
  methods: {
    ...mapActions("data", ["loadCasePeopleAttributions"]),
    ...mapMutations("data", ["incrementCaseSummaryUpdateCount"]),
    loadPeople() {
      if (!isDefined(this.caseId)) return;
      this.loading = true;
      this.loadCasePeopleAttributions({caseId: this.caseId}).then(() => {
        this.loaded = true;
      }).catch((ex) => {
        this.$notifyError("Failed to load People", ex);
      }).finally(() => {
        this.loading = false;
      });
    },
    openAddPeopleModal() {
      this.$refs.addPeople.showModal = true;
    },
    removeAttribution(data) {
      if (isDefined(data) && isDefined(data.type) && isDefined(data.id)) {
        if (data.type === "users") {
          this.removeUserAttribute(data.id);
        } else {
          this.removeActorAttribute(data.id);
        }
      }
    },
    removeActorAttribute(actorAttributeId) {
      if (this.removing) return;
      this.removing = true;
      unattributeActor(actorAttributeId).then((r) => {
        this.incrementCaseSummaryUpdateCount();
        this.$notifySuccess("Successfully removed Subject from Case");
        this.loadPeople();
      }).catch((ex) => {
        this.$notifyError("Unable to remove Subject from Case, please try again", ex);
      }).finally(() => {
        this.removing = false;
      });
    },
    removeUserAttribute(userAttributeId) {
      if (this.removing) return;
      this.removing = true;
      unattributeUser(userAttributeId).then((r) => {
        this.incrementCaseSummaryUpdateCount();
        this.$notifySuccess("Successfully removed LEO from Case");
        this.loadPeople();
      }).catch((ex) => {
        this.$notifyError("Unable to remove LEO from Case, please try again", ex);
      }).finally(() => {
        this.removing = false;
      });
    },
    viewActor(id) {
      this.$router.replace({
        name: ethosRouteNames.CasePeople,
        params: {
          caseId: this.caseId,
          actorId: id,
        },
      });
    },
  },
};
</script>

<style lang="scss">
h6 {
  &--title {
    font-size: 20px;
  }
}
</style>
